import useSearchResultsCount from "@SearchResults/hooks/useSearchResultsCount";
import useLocale from "@Hooks/selector/useLocale";

/**
 * Checks if search results has at least N results
 */
export default function useHasSearchResults(atLeast: number = 1, includeUnavailable = true) {
    const searchResultsCount = useSearchResultsCount(includeUnavailable)
    return searchResultsCount >= atLeast
}